import { FaceLaugh, FacePokerface, FaceSad } from "@monta/icons";
import { useMemo } from "react";
import styles from "./styles.module.scss";

type Props = {
  tithe: number;
};

const Tithe = (props: Props) => {
  const { tithe } = props;

  const generateTithe = useMemo(() => {
    if ([1, 2, 3].includes(tithe))
      return {
        icon: <FaceLaugh />,
        text: "خــــــــــــــــــــوب",
        className: styles["tithe__text--green"]
      };
    if ([4, 5, 6].includes(tithe))
      return {
        icon: <FacePokerface />,
        text: "متـــــــــــــــــوسط",
        className: styles["tithe__text--blue"]
      };
    if ([7, 8, 9, 10].includes(tithe))
      return {
        icon: <FaceSad />,
        text: "ضعـیـــــــــــــــــف",
        className: styles["tithe__text--red"]
      };
  }, [tithe]);

  return (
    <div className={styles["tithe"]}>
      <div className={styles["tithe__text"]}>
        <span className={styles["tithe__text--orange"]}>
          جزو دهک {tithe} هستید
        </span>
        <span className={generateTithe?.className}>{generateTithe?.text}</span>
      </div>
      {generateTithe?.icon}
    </div>
  );
};

export default Tithe;
